import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  chatProfileApiRag,
  type ChatProfileRequest,
  type ChatProfileResponse,
} from "@/generated/fastapi";

export async function chatProfile(
  accessToken: string | null | undefined,
  request: ChatProfileRequest,
): Promise<ChatProfileResponse | null | undefined> {
  try {
    const response = await chatProfileApiRag({
      client: browserFastApiClient,
      body: request,
      auth: requireFastApiAccessToken(accessToken),
    });

    if (!response || !response.data) {
      console.error("No response data from chatProfile", response?.message);
      return null;
    }

    return response.data as ChatProfileResponse;
  } catch (error) {
    console.error("chatProfile error:", error);
    return null;
  }
}
